export default "__VITE_ASSET__CWGM7ttR__"